<template>
  <div class="nav">
    <nav class="nav-bar">
      <div class="nav-bar-comtainer">
        <div class="nav-content">
          <ul>
            <li
              v-for="(item,index) in navBarList"
              :key="index"
              :class="currentIndex===index?'active':''"
              @click="scrollTo(index)"
            >
              <span v-if="index!==3">{{item}}</span>
              <div v-else class="button-login" @click="loginClick">{{item}}</div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { slideTo } from "../../utils";
export default {
  name: "navHeader",
  data() {
    return {
      currentIndex: -1,
      navBarList: [],
      scroll_num: []
    };
  },
  methods: {
    scrollTo(index) {
      this.currentIndex = index;
      slideTo(this.scroll_num[index]);
      if (index !== 3) {
        this.$emit("loginClick", false);
      }
    },
    loginClick() {
      // this.$emit("loginClick", true);
      this.$router.push('/login')
      this.currentIndex = -1;
    }
  },
  created() {
    window.addEventListener("scroll", e => {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop <= 100) {
        this.currentIndex = -1;
      }
    });
  },
  mounted() {
    const endScroll =
      document.getElementById("home").scrollHeight -
      document.getElementsByClassName("select-5")[0].scrollHeight -
      document.getElementsByClassName("select-6")[0].scrollHeight;
    const standScreen = 1050;
    let screenRate = standScreen / window.screen.height;
    this.scroll_num = [660, 1820, screenRate * (endScroll), 0];
  }
};
</script>

<style lang="scss" scoped>
.nav-bar {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 69px;
  background: RGBA(0, 27, 105, 1);
  .nav-bar-comtainer {
    width: 1024px;
    height: 100%;
    margin: 0 auto;
    .logo {
      float: left;
      height: 69px;
      img {
        margin-top: 15px;
      }
    }
    .nav-content {
      vertical-align: top;
      float: right;
      ul {
        display: inline-block;
        li {
          display: inline-block;
          cursor: pointer;
          font-size: 16px;
          height: 69px;
          padding: 1px 0;
          box-sizing: border-box;
          line-height: 69px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.85);
          margin-right: 90px;
          &.active {
            border-bottom: 4px solid rgba(245, 145, 54, 1);
            border-radius: 3px;
          }
        }
      }
      .button-login {
        display: inline-block;
        width: 89px;
        height: 32px;
        border-radius: 16px;
        opacity: 0.62;
        line-height: 32px;
        border: 1px solid rgba(255, 255, 255, 1);
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        cursor: pointer;
        &.active {
          border-bottom: 4px solid rgba(245, 145, 54, 1);
          border-radius: 3px;
        }
      }
    }
  }
}
</style>